import React from 'react';
import { withAdminAccount } from '../../hocs/withAdminAccount';

const AdminOverviewComponent = () => {
  return <div>Overview</div>;
};

export const AdminOverview = withAdminAccount(AdminOverviewComponent);
